import { render, staticRenderFns } from "./TicketAddTouristInfo.vue?vue&type=template&id=5f511168&scoped=true"
import script from "./TicketAddTouristInfo.vue?vue&type=script&lang=js"
export * from "./TicketAddTouristInfo.vue?vue&type=script&lang=js"
import style0 from "./TicketAddTouristInfo.vue?vue&type=style&index=0&id=5f511168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f511168",
  null
  
)

export default component.exports